import { Box, Button, IconButton, Typography, Grid } from '@material-ui/core';
import { useRef, useState } from 'react';
import { toast } from 'react-toastify';
import { i18n } from '../../translate/i18n';
import DeleteOutlineOutlinedIcon from '@material-ui/icons/DeleteOutlineOutlined';

const FileUploader = ({ disabled, csvUpload, contacts, currentFiles, setCurrentFiles }) => {
    const fileInputRef = useRef(null);

    const handleButtonClick = () => {
        if (fileInputRef.current) {
            fileInputRef.current.click();
        }
    };

    const handleDragOver = (event) => {
        event.preventDefault();
        event.stopPropagation();
    };

    const handleDrop = (event) => {
        event.preventDefault();
        event.stopPropagation();
        if (!fileInputRef || !fileInputRef?.current?.accept) return;

        const files = Array.from(event.dataTransfer.files);
        if (files.length > 1) return;
        // Extensões permitidas
        const acceptedFormats = fileInputRef.current.accept.split(',');

        // Filtra os arquivos aceitos com base nas extensões
        const validFiles = files.filter((file) => {
            const fileExtension = file.name.split('.').pop().toLowerCase();
            return acceptedFormats.includes(`.${fileExtension}`);
        });

        if (validFiles.length == 0) {
            toast.error(i18n.t("Formato de arquivo inválido."));
            return;
        }

        csvUpload({ target: { files } });
        if (fileInputRef.current) fileInputRef.current.value = '';
    };

    return (
        <>
            <Grid
                container
                spacing={2}
                style={{
                    marginTop: "10px",
                    marginBottom: "10px"
                }}
            >
                <Grid item xs={12}>
                    <Box
                        component="div"
                        onDragOver={handleDragOver}
                        onDrop={handleDrop}
                        sx={{
                            border: '2px dashed',
                            borderColor: (theme) => theme.palette.mode === 'dark' ? '#424242' : '#bdbdbd',
                            color: (theme) => theme.palette.text.primary,
                            borderRadius: '8px',
                            padding: '20px',
                            textAlign: 'center',
                            cursor: 'pointer',
                            backgroundColor: (theme) => theme.palette.mode === 'dark' ? '#616161' : '#eeeeee',
                        }}
                    >
                        {
                            currentFiles[0]?.name 
                            &&
                            <>
                                <Typography variant="h6">{currentFiles[0].name}</Typography>
                                <IconButton 
                                    aria-label="clear"
                                    title="Excluir Arquivo"
                                    onClick={() => {
                                        if (fileInputRef.current) fileInputRef.current.value = '';
                                        if (setCurrentFiles) setCurrentFiles([]);
                                    }}
                                    style={{
                                        position: "absolute",
                                        top: "25px",
                                        right: "10px",
                                    }}
                                >
                                    <DeleteOutlineOutlinedIcon color="secondary" />
                                </IconButton>
                            </>
                        }
                        <Typography component="p" sx={{ marginBottom: "20px" }}>{i18n.t("contacts.validateContacts.dragText")}</Typography>
                        <Button
                            type="button"
                            disabled={disabled}
                            onClick={handleButtonClick}
                            style={{
                                padding: '10px 20px',
                                backgroundColor: '#007bff',
                                color: '#fff',
                                border: 'none',
                                borderRadius: '4px',
                                cursor: 'pointer',
                            }}
                        >
                            {
                                currentFiles[0]?.name 
                                ?
                                i18n.t("contacts.validateContacts.changeFile")
                                :
                                i18n.t("contacts.validateContacts.selectFile")
                            }
                        </Button>
                        <input
                            type="file"
                            ref={fileInputRef}
                            style={{ display: 'none' }}
                            accept={".xlsx,.csv"}
                            onChange={(e) => {
                                csvUpload(e);
                            }}
                            disabled={disabled}
                        />
                    </Box>
                </Grid>
            </Grid>
            {
                (Array.isArray(contacts) && contacts.length > 0)
                &&
                <Grid
                    container
                    spacing={2}
                    style={{
                        marginBottom: "10px"
                    }}
                >
                    <Grid item xs={12}>
                        Total de Contatos: {Array.isArray(contacts) ? contacts.length : 0}
                    </Grid>
                </Grid>
            }
        </>
    );
}

export default FileUploader;
